import React, { useRef,useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { LIMIT_PAGE_SIZE_SLIDE, ENDPOINT, LIMIT_PAGE} from "constants/variables";
import { setFilters, resetFilters} from 'reducers/filtersPurchaseDeliverySlice';
import { resetPagination } from 'reducers/paginationPurchaseDeliverySlice';
import { useTranslation } from "react-i18next"
import { useNavigate } from 'react-router-dom';
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { es } from 'date-fns/locale';
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle'; 
import MenuItem  from "@mui/material/MenuItem"; 
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction, warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { NumericFormat } from 'components/utils/NumericFormat'; 
import PropTypes from 'prop-types';  
import TableSortingPurchaseDelivery from "pages/purchases/purchaseDeliveryFilterList/SortingTablesPurchaseDelivery";
import exportToExcel from "pages/purchases/purchaseDeliveryFilterList/PurchaseDeliveryExportToExcel";
import exportToPDF from "pages/purchases/purchaseDeliveryFilterList/PurchaseDeliveryExportToPDF";
import PurchaseDeliveryPDF from "pages/purchases/generatePDF/PurchaseDeliveryPDF";

const initialState = {
  idFrom: "",
  idTo: "",
  substoreFrom: "",
  substoreTo: "",
  purchasenoteFrom: "",
  purchasenoteTo: "",
  datepurchaseFrom: null,
  datepurchaseTo: null,
  opt_tras_store_idFrom: "", 
  opt_tras_store_idTo: "",
  opt_tras_licenseplateFrom: "", 
  opt_tras_licenseplateTo: "",
  marcaFrom: "",
  marcaTo: "",
  modeloFrom: "",
  modeloTo: "",
  amountFROM:0,
  amountTO:0,
  paymentFromES: "",
  paymentToES: "",
  paymentFromEN: "",
  paymentToEN: ""
};

const initialVehicleToSelect = [{
  "id": "",
  "licenseplate": "" 
}];
  
const initialPaymentToSelect = [{
  "id": "",
  "code": "",
  "namees": "",
  "nameen": "",
}];
  
const initialStatePurchseDelivery = [{
  "id" : "",
  "defaultStore_id": 0, 
  "useraccount_id": 0, 
  "substore_id": 0, 
  "purchasenote":0, 
  "ownnumberpurchase":"",  
  "datepurchase" : null, 
  "opt_tras_tradename": "",
  "opt_tras_licenseplate": "",
  "vehiclestore_frame": "",
  "vehicle_marca": "",
  "vehicle_model": "",
  "totalpurchase" : 0 ,
  "payment_id" : 0 ,
  "payment_code": "",
  "payment_namees": "",
  "payment_nameen": "" 
}];

const initialMarcaToSelect = [{
  "id": "",
  "marca": ""
}];

const initialModelToSelect = [{
  "id": "",
  "model": ""
}];

const initialStoresToSelect = [{
  "id": "",
  "documentid": "",
  "tradename": ""
}];

const PurchaseDeliveryFilter = ({ showModalPurchasesDeliverySettings,setShowModalPurchasesDeliverySettings,typeOfList}) => {
  const {t,i18n} = useTranslation(['listDataPurchases']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const defaultStore = useSelector((state) => state.loginUser.defaultStore);   
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code);  
  const DELETE_CODE_FORMDI = useSelector((state) => state.formatDIUser.delete_code_formdi);   
  const [dataPurchaseDelivery, setDataPurchaseDelivery] = useState(initialStatePurchseDelivery);
  const [formPurchaseDelivery, setFormPurchaseDelivery] = useState(initialStatePurchseDelivery[0]);
  const filtersPurchaseDelivery = useSelector((state) => state.filtersPurchaseDelivery);
  const [filterPurchase,setFilterPurchase]=useState(filtersPurchaseDelivery);
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegPurchaseDelivery,setNumTotRegPurchaseDelivery]= useState(0);
  const [errorsFiltersPurchaseDelivery, setErrorsFiltersPurchaseDelivery] = useState({});
  const [inputTextPurchaseDelivery, setInputTextPurchaseDelivery] = useState("");  
  const [openDeleteRowPurchaseDelivery,setOpenDeleteRowPurchaseDelivery]= useState(false); ;  
  const [openEditRowPurchaseDelivery,setOpenEditRowPurchaseDelivery]= useState(false);
  const [openEditFilterPurchaseDelivery,setOpenEditFilterPurchaseDelivery]= useState(false); 
  const [rowEditPurchaseDelivery,setRowEditPurchaseDelivery]= useState(initialStatePurchseDelivery[0]);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorPurchaseDelivery, setIsLoadingErrorPurchaseDelivery] = useState(false);
  const [idCodeDelete,setIdCodeDelete]=useState(DELETE_CODE); 
  const [viewPDF,setViewPDF]=useState(false);  
  const dispatch = useDispatch();
  const [activeOffsetPurchaseDelivery, setActiveOffsetPurchaseDelivery]= useState(false);
  const [currencyOffsetPurchaseDelivery, setCurrencyOffsetPurchaseDelivery] = useState(0);
  const [rangeOffsetPurchaseDelivery, setRangeOffsetPurchaseDelivery] = useState([{}]); 

  const [tradenameToSelect,setTradenameToSelect]= useState(initialStoresToSelect); 
  const [filteredStoreFrom, setFilteredStoreFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexStoreFrom, setHighlightedIndexStoreFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredStoreTo, setFilteredStoreTo] = useState([]); // Opciones filtradas
  const [highlightedIndexStoreTo, setHighlightedIndexStoreTo] = useState(-1); // Índice de la opción resaltada 
  
  const [vehiclesToSelect,setVehiclesToSelect]= useState(initialVehicleToSelect); 
  const [filteredVehicleFrom, setFilteredVehicleFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexVehicleFrom, setHighlightedIndexVehicleFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredVehicleTo, setFilteredVehicleTo] = useState([]); // Opciones filtradas
  const [highlightedIndexVehicleTo, setHighlightedIndexVehicleTo] = useState(-1); // Índice de la opción resaltada 
  
  const [marcaToSelect,setMarcaToSelect]= useState(initialMarcaToSelect); 
  const [filteredMarcaFrom, setFilteredMarcaFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexMarcaFrom, setHighlightedIndexMarcaFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredMarcaTo, setFilteredMarcaTo] = useState([]); // Opciones filtradas
  const [highlightedIndexMarcaTo, setHighlightedIndexMarcaTo] = useState(-1); // Índice de la opción resaltada
  const [modelToSelect,setModelToSelect]= useState(initialModelToSelect); 
  const [filteredModelFrom, setFilteredModelFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexModelFrom, setHighlightedIndexModelFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredModelTo, setFilteredModelTo] = useState([]); // Opciones filtradas
  const [highlightedIndexModelTo, setHighlightedIndexModelTo] = useState(-1); // Índice de la opción resaltada
  const ddRefStoreFrom = useRef(null);
  const ddRefStoreTo = useRef(null);
  const ddRefMarcaFrom = useRef(null);
  const ddRefMarcaTo = useRef(null);
  const ddRefModelFrom = useRef(null);
  const ddRefModelTo = useRef(null);
  const ddRefVehicleFrom = useRef(null);
  const ddRefVehicleTo = useRef(null); 
  const [paymenetTypeSelect,setPaymenetTypeSelect]= useState(initialPaymentToSelect); 
  const [refeshData,setRefeshData]=useState(false); 

  const navigate = useNavigate(); 

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalPurchasesDeliverySettings) {
        setDataPurchaseDelivery(initialStatePurchseDelivery);
        setFormPurchaseDelivery(initialStatePurchseDelivery[0]); 
        setNumTotRegFilter(0);
        setNumTotRegPurchaseDelivery(0);
        setErrorsFiltersPurchaseDelivery({});
        setInputTextPurchaseDelivery(""); 
        setOpenDeleteRowPurchaseDelivery(false); ;
        setOpenEditRowPurchaseDelivery(false);
        setOpenEditFilterPurchaseDelivery(false);
        setRowEditPurchaseDelivery(initialStatePurchseDelivery[0]);
        setIsLoadingErrorPurchaseDelivery(false);
        setIdCodeDelete(DELETE_CODE);  
        setRefeshData(false); 
        setActiveOffsetPurchaseDelivery(false);
        setCurrencyOffsetPurchaseDelivery(0);
        setRangeOffsetPurchaseDelivery([{}]); 
        setShowModalPurchasesDeliverySettings(false);  
        setTradenameToSelect(initialStoresToSelect);
        setFilteredStoreFrom([]);
        setHighlightedIndexStoreFrom(-1); 
        setFilteredStoreTo([]);  
        setHighlightedIndexStoreTo(-1);  
       
        setMarcaToSelect(initialMarcaToSelect);
        setFilteredMarcaFrom([]);
        setHighlightedIndexMarcaFrom(-1); 
        setFilteredMarcaTo([]);  
        setHighlightedIndexMarcaTo(-1);   
        setModelToSelect(initialModelToSelect);
        setFilteredModelFrom([]);
        setHighlightedIndexModelFrom(-1); 
        setFilteredModelTo([]);  
        setHighlightedIndexModelTo(-1);  
        setVehiclesToSelect(initialVehicleToSelect);
        setFilteredVehicleFrom([]);
        setHighlightedIndexVehicleFrom(-1);  
        setFilteredVehicleTo([]);
        setHighlightedIndexVehicleTo(-1);   
        dispatch(setLoading(false));
        dispatch(resetPagination());
        dispatch(resetFilters());
        setFilterPurchase(filtersPurchaseDelivery);
        navigate("/home");
        return () => {};
      }
    },
    [ setDataPurchaseDelivery,
      setFormPurchaseDelivery, 
      setNumTotRegFilter,
      setFilterPurchase,
      filtersPurchaseDelivery,
      setNumTotRegPurchaseDelivery,
      setErrorsFiltersPurchaseDelivery,
      setInputTextPurchaseDelivery, 
      setOpenDeleteRowPurchaseDelivery,  
      setOpenEditRowPurchaseDelivery,
      setOpenEditFilterPurchaseDelivery,
      setRowEditPurchaseDelivery, 
      setIsLoadingErrorPurchaseDelivery,
      setIdCodeDelete,  
      setRefeshData, 
      setActiveOffsetPurchaseDelivery,
      setCurrencyOffsetPurchaseDelivery,
      setRangeOffsetPurchaseDelivery,    
      setTradenameToSelect,
      setFilteredStoreFrom,
      setHighlightedIndexStoreFrom, 
      setFilteredStoreTo,  
      setHighlightedIndexStoreTo,
      setMarcaToSelect,
      setFilteredMarcaFrom,
      setHighlightedIndexMarcaFrom, 
      setFilteredMarcaTo,
      setHighlightedIndexMarcaTo, 
      setModelToSelect,
      setFilteredModelFrom,
      setHighlightedIndexModelFrom,
      setFilteredModelTo,
      setHighlightedIndexModelTo,  
      setVehiclesToSelect,
      setFilteredVehicleFrom,
      setHighlightedIndexVehicleFrom, 
      setFilteredVehicleTo,
      setHighlightedIndexVehicleTo,   
      setShowModalPurchasesDeliverySettings,
      showModalPurchasesDeliverySettings, 
      navigate,
      dispatch,
      DELETE_CODE]
  );

  const closeModalPurchaseDelivery = () => {    
    setDataPurchaseDelivery(initialStatePurchseDelivery);
    setFormPurchaseDelivery(initialStatePurchseDelivery[0]); 
    setNumTotRegFilter(0);
    setNumTotRegPurchaseDelivery(0);
    setErrorsFiltersPurchaseDelivery({});
    setInputTextPurchaseDelivery(""); 
    setOpenDeleteRowPurchaseDelivery(false);  
    setOpenEditRowPurchaseDelivery(false);
    setOpenEditFilterPurchaseDelivery(false);
    setRowEditPurchaseDelivery(initialStatePurchseDelivery[0]);
    setIsLoadingErrorPurchaseDelivery(false);
    setIdCodeDelete(DELETE_CODE);  
    setRefeshData(false); 
    setActiveOffsetPurchaseDelivery(false);
    setCurrencyOffsetPurchaseDelivery(0);
    setRangeOffsetPurchaseDelivery([{}]);  
    setShowModalPurchasesDeliverySettings(false);
    dispatch(setLoading(false));
    setTradenameToSelect(initialStoresToSelect);
    setFilteredStoreFrom([]);
    setHighlightedIndexStoreFrom(-1); 
    setFilteredStoreTo([]);  
    setHighlightedIndexStoreTo(-1);  
    setMarcaToSelect(initialMarcaToSelect);
    setFilteredMarcaFrom([]);
    setHighlightedIndexMarcaFrom(-1); 
    setFilteredMarcaTo([]);  
    setHighlightedIndexMarcaTo(-1);   
    setModelToSelect(initialModelToSelect);
    setFilteredModelFrom([]);
    setHighlightedIndexModelFrom(-1); 
    setFilteredModelTo([]);  
    setHighlightedIndexModelTo(-1);  
    setVehiclesToSelect(initialVehicleToSelect);
    setFilteredVehicleFrom([]);
    setHighlightedIndexVehicleFrom(-1);  
    setFilteredVehicleTo([]);
    setHighlightedIndexVehicleTo(-1);   
    dispatch(resetPagination());
    dispatch(resetFilters()); 
    setFilterPurchase(filtersPurchaseDelivery);
    navigate("/home");
    return () => {};
  };
 
  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    }, [callback, delay]);
  };

  // Dentro del componente
  const debouncedHandleSearchStoreFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredStoreFrom([]);
      setHighlightedIndexStoreFrom(-1);
      return;
    }
    const filtered = tradenameToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredStoreFrom(filtered);
    setHighlightedIndexStoreFrom(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectStoreFrom = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFilterPurchase(filterPurchase => ({
      ...filterPurchase,
      opt_tras_store_idFrom: store.tradename || "",
      opt_tras_store_idTo: store.tradename || filterPurchase.opt_tras_store_idTo
    }));
    setFilteredStoreFrom([]);
    setHighlightedIndexStoreFrom(-1);
  }; 
  const handleKeyDownStoreFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredStoreFrom.length === 0 && filterPurchase.opt_tras_store_idFrom.trim() === "") {
        setFilteredStoreFrom(tradenameToSelect);
        setHighlightedIndexStoreFrom(0);
      } else {
        setHighlightedIndexStoreFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredStoreFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex,ddRefStoreFrom);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexStoreFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid,ddRefStoreFrom);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexStoreFrom >= 0) {
      if (highlightedIndexStoreFrom >= 0 && highlightedIndexStoreFrom < filteredStoreFrom.length) {
        handleSelectStoreFrom(filteredStoreFrom[highlightedIndexStoreFrom]);
      }
    } else if (event.key === "Escape" ) {
      const isValid = tradenameToSelect.some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filterPurchase.opt_tras_store_idFrom.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setFilterPurchase(filterPurchase => ({
          ...filterPurchase,
          opt_tras_store_idFrom: ""
        }));
      }
      setFilteredStoreFrom([]);
      setHighlightedIndexStoreFrom(-1);
    }
  };
  // Dentro del componente
  const debouncedHandleSearchStoreTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredStoreTo([]);
      setHighlightedIndexStoreTo(-1);
      return;
    }
    const filtered = tradenameToSelect
      .filter(store=>(store.tradename>=filterPurchase.opt_tras_store_idFrom))
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredStoreTo(filtered);
    setHighlightedIndexStoreTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectStoreTo = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFilterPurchase(filterPurchase => ({
    ...filterPurchase,
    opt_tras_store_idTo:  store.tradename || ""
  }));
  setFilteredStoreTo([]);
  setHighlightedIndexStoreTo(-1);
  }; 
  const handleKeyDownStoreTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredStoreTo.length === 0 && filterPurchase.opt_tras_store_idTo.trim() === "") {
        const filtered = tradenameToSelect.filter(item=>(item.tradename>=filterPurchase.opt_tras_store_idFrom));
        setFilteredStoreTo(filtered);
        setHighlightedIndexStoreTo(0);
      } else {
        setHighlightedIndexStoreTo((prevIndex) => {
          const nextIndex = prevIndex < filteredStoreTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex,ddRefStoreTo);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexStoreTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid,ddRefStoreTo);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexStoreTo >= 0) {
      if (highlightedIndexStoreTo >= 0 && highlightedIndexStoreTo < filteredStoreTo.length) {
        handleSelectStoreTo(filteredStoreTo[highlightedIndexStoreTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = tradenameToSelect
      .filter(item=>(item.tradename>=filterPurchase.opt_tras_store_idFrom))
      .some((store) => {
      if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filterPurchase.opt_tras_store_idTo.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
    }); 
    if (!isValid) {
      setFilterPurchase(filterPurchase => ({
        ...filterPurchase,
        opt_tras_store_idTo:  ""
      }));
    }
    setFilteredStoreTo([]);
    setHighlightedIndexStoreTo(-1);
    }
  };  

  const debouncedHandleSearchVehicleFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredVehicleFrom([]);
      setHighlightedIndexVehicleFrom(-1);
      return;
    }
    const filtered = vehiclesToSelect
      .filter(vehicle => vehicle && vehicle.licenseplate)
      .filter(vehicle => {
        const licenseplateFROM = vehicle.licenseplate.toUpperCase();
         return licenseplateFROM.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredVehicleFrom(filtered);
      setHighlightedIndexVehicleFrom(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectVehicleFrom = (vehicle) => {
    if (!vehicle) return; // Validación adicional para evitar errores
    setFilterPurchase(filterPurchase => ({
      ...filterPurchase,
      opt_tras_licenseplateFrom: vehicle.licenseplate || "",
      opt_tras_licenseplateTo: vehicle.licenseplate || filterPurchase.opt_tras_licenseplateTo,
    }));
    setFilteredVehicleFrom([]);
    setHighlightedIndexVehicleFrom(-1);
  }; 
  const handleKeyDownVehicleFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredVehicleFrom.length === 0 && filterPurchase.opt_tras_licenseplateFrom.trim() === "") {
        setFilteredVehicleFrom(vehiclesToSelect);
        setHighlightedIndexVehicleFrom(0);
      } else {
        setHighlightedIndexVehicleFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredVehicleFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex,ddRefVehicleFrom);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexVehicleFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid,ddRefVehicleFrom);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexVehicleFrom >= 0) {
      if (highlightedIndexVehicleFrom >= 0 && highlightedIndexVehicleFrom < filteredVehicleFrom.length) {
        handleSelectVehicleFrom(filteredVehicleFrom[highlightedIndexVehicleFrom]);
      }
    } else if (event.key === "Escape") {
      const isValid = vehiclesToSelect.some((vehicle) => {
        if (!vehicle || !vehicle.licenseplate) return false; 
        const normalizedVehicle = vehicle.licenseplate.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputVehicle = filterPurchase.opt_tras_licenseplateFrom.toUpperCase().replace(/[.-]/g, "");
        return normalizedVehicle === normalizedInputVehicle;
      }); 
      if (!isValid) {
        setFilterPurchase(filterPurchase => ({
          ...filterPurchase,
          opt_tras_licenseplateFrom: ""
        }));
      }
      setFilteredVehicleFrom([]);
      setHighlightedIndexVehicleFrom(-1);
    }
  };
  // Dentro del componente
  const debouncedHandleSearchVehicleTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredVehicleTo([]);
      setHighlightedIndexVehicleTo(-1);
      return;
    }
    const filtered = vehiclesToSelect
      .filter(vehicle=>(vehicle.licenseplate>=filterPurchase.opt_tras_licenseplateFrom))
      .filter(vehicle => vehicle && vehicle.licenseplate)
      .filter(vehicle => {
        const licenseplate = vehicle.licenseplate.toUpperCase();
        return licenseplate.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredVehicleTo(filtered);
      setHighlightedIndexVehicleTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectVehicleTo = (vehicle) => {
    if (!vehicle) return; // Validación adicional para evitar errores
    setFilterPurchase(filterPurchase => ({
      ...filterPurchase,
      opt_tras_licenseplateTo: vehicle.licenseplate || ""
    })); 
    setFilteredVehicleTo([]);
    setHighlightedIndexVehicleTo(-1);
  }; 
  const handleKeyDownVehicleTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredVehicleTo.length === 0 && filterPurchase.opt_tras_licenseplateTo.trim() === "") {
        const filtered = vehiclesToSelect.filter(item=>(item.licenseplate>=filterPurchase.opt_tras_licenseplateFrom));
        setFilteredVehicleTo(filtered);
        setHighlightedIndexVehicleTo(0);
      } else {
        setHighlightedIndexVehicleTo((prevIndex) => {
          const nextIndex = prevIndex < filteredVehicleTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex,ddRefVehicleTo);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexVehicleTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid,ddRefVehicleTo);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexVehicleTo >= 0) {
      if (highlightedIndexVehicleTo >= 0 && highlightedIndexVehicleTo < filteredVehicleTo.length) {
        handleSelectVehicleTo(filteredVehicleTo[highlightedIndexVehicleTo]);
      }
    } else if (event.key === "Escape" ) {
      const isValid = vehiclesToSelect
      .filter(item=>(item.licenseplate>=filterPurchase.opt_tras_licenseplateFrom))
      .some((vehicle) => {
        if (!vehicle || !vehicle.licenseplate) return false; 
        const normalizedVehicle = vehicle.licenseplate.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputVehicle = filterPurchase.opt_tras_licenseplateTo.toUpperCase().replace(/[.-]/g, "");
        return normalizedVehicle === normalizedInputVehicle;
      }); 
      if (!isValid) {
        setFilterPurchase(filterPurchase => ({
          ...filterPurchase,
          opt_tras_licenseplateTo: ""
        }));   
      }
      setFilteredVehicleTo([]);
      setHighlightedIndexVehicleTo(-1);
    }
  }; 

  // Dentro del componente
  const debouncedHandleSearchMarcaFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredMarcaFrom([]);
      setHighlightedIndexMarcaFrom(-1);
      return;
    }
    const filtered = marcaToSelect
      .filter(vehicletype => vehicletype && vehicletype.marca)
      .filter(vehicletype => {
        const marcaFROM = vehicletype.marca.toUpperCase();
        return marcaFROM.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredMarcaFrom(filtered);
      setHighlightedIndexMarcaFrom(0);
  }, 300);
  
  // Manejo de la selección de una tienda
  const handleSelectMarcaFrom = (vehicletype) => {
    if (!vehicletype) return; // Validación adicional para evitar errores
    setFilterPurchase(filterPurchase => ({
      ...filterPurchase,
      marcaFrom: vehicletype.marca || "",
      marcaTo: vehicletype.marca || filterPurchase.marcaTo,
    })); 
    setFilteredMarcaFrom([]);
    setHighlightedIndexMarcaFrom(-1);
  }; 

  const handleKeyDownMarcaFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredMarcaFrom.length === 0 && filterPurchase.marcaFrom.trim() === "") {
        setFilteredMarcaFrom(marcaToSelect);
        setHighlightedIndexMarcaFrom(0);
      } else {
        setHighlightedIndexMarcaFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredMarcaFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex,ddRefMarcaFrom);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexMarcaFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid,ddRefMarcaFrom);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexMarcaFrom >= 0) {
      if (highlightedIndexMarcaFrom >= 0 && highlightedIndexMarcaFrom < filteredMarcaFrom.length) {
        handleSelectMarcaFrom(filteredMarcaFrom[highlightedIndexMarcaFrom]);
      }
    } else if (event.key === "Escape") {
      const isValid = marcaToSelect.some((vehicletype) => {
        if (!vehicletype || !vehicletype.marca) return false; 
        const normalizedMarca = vehicletype.marca.toUpperCase();
        const normalizedInputMarca = filterPurchase.marcaFrom.toUpperCase();
        return normalizedMarca === normalizedInputMarca;
      }); 
      if (!isValid) {
        setFilterPurchase(filterPurchase => ({
          ...filterPurchase,
          marcaFrom: "" 
        })); 
      }
      setFilteredMarcaFrom([]);
      setHighlightedIndexMarcaFrom(-1);
    }
  }; 

  // Dentro del componente
  const debouncedHandleSearchMarcaTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredMarcaTo([]);
      setHighlightedIndexMarcaTo(-1);
      return;
    }
    const filtered = marcaToSelect
      .filter(vehicletype=>(vehicletype.marca>=filterPurchase.marcaFrom))
      .filter(vehicletype => vehicletype && vehicletype.marca)
      .filter(vehicletype => {
        const marca = vehicletype.marca.toUpperCase();
        return marca.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredMarcaTo(filtered);
    setHighlightedIndexMarcaTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectMarcaTo = (vehicletype) => {
    if (!vehicletype) return; // Validación adicional para evitar errores
    setFilterPurchase(filterPurchase => ({
    ...filterPurchase,
    marcaTo:  vehicletype.marca || ""
  }));
  setFilteredMarcaTo([]);
  setHighlightedIndexMarcaTo(-1);
  }; 
  const handleKeyDownMarcaTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredMarcaTo.length === 0 && filterPurchase.marcaTo.trim() === "") {
        const filtered = marcaToSelect.filter(item=>(item.marca>=filterPurchase.marcaFrom));
        setFilteredMarcaTo(filtered);
        setHighlightedIndexMarcaTo(0);
      } else {
        setHighlightedIndexMarcaTo((prevIndex) => {
          const nextIndex = prevIndex < filteredMarcaTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex,ddRefMarcaTo);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexMarcaTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid,ddRefMarcaTo);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexMarcaTo >= 0) {
      if (highlightedIndexMarcaTo >= 0 && highlightedIndexMarcaTo < filteredMarcaTo.length) {
        handleSelectMarcaTo(filteredMarcaTo[highlightedIndexMarcaTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = marcaToSelect
      .filter(item=>(item.marca>=filterPurchase.marcaFrom))
      .some((vehicletype) => {
      if (!vehicletype || !vehicletype.marca) return false; 
        const normalizedMarca = vehicletype.tradename.toUpperCase();
        const normalizedInputMarca = filterPurchase.marcaTo.toUpperCase();
        return normalizedMarca === normalizedInputMarca;
    }); 
    if (!isValid) {
      setFilterPurchase(filterPurchase => ({
        ...filterPurchase,
        marcaTo:  ""
      }));
    }
    setFilteredMarcaTo([]);
    setHighlightedIndexMarcaTo(-1);
    }
  }; 
  
  // Dentro del componente
  const debouncedHandleSearchModelFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredModelFrom([]);
      setHighlightedIndexModelFrom(-1);
      return;
    }
    const filtered = modelToSelect
      .filter(vehicletype => vehicletype && vehicletype.model)
      .filter(vehicletype => {
        const model = vehicletype.model.toUpperCase(); 
        return model.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredModelFrom(filtered);
    setHighlightedIndexModelFrom(0);
  }, 300); 
  // Manejo de la selección de una tienda
    const handleSelectModelFrom = (vehicletype) => {
    if (!vehicletype) return; // Validación adicional para evitar errores
    setFilterPurchase(filterPurchase => ({
      ...filterPurchase,
      modeloFrom: vehicletype.model || "",
      modeloTo: vehicletype.model || filterPurchase.modeloTo 
    }));
    setFilteredModelFrom([]);
    setHighlightedIndexModelFrom(-1);
  }; 
  const handleKeyDownModelFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredModelFrom.length === 0 && filterPurchase.modeloFrom.trim() === "") {
        setFilteredModelFrom(modelToSelect);
        setHighlightedIndexModelFrom(0);
      } else {
        setHighlightedIndexModelFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredModelFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex,ddRefModelFrom);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexModelFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid,ddRefModelFrom);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexModelFrom >= 0) {
      if (highlightedIndexModelFrom >= 0 && highlightedIndexModelFrom < filteredModelFrom.length) {
        handleSelectModelFrom(filteredModelFrom[highlightedIndexModelFrom]);
      }
    } else if (event.key === "Escape" ) {
      const isValid = modelToSelect.some((vehicletype) => {
        if (!vehicletype || !vehicletype.model) return false; 
        const normalizedModel = vehicletype.model.toUpperCase();
        const normalizedInputModel = filterPurchase.modeloFrom.toUpperCase();
        return normalizedModel === normalizedInputModel;
      }); 
      if (!isValid) {
        setFilterPurchase(filterPurchase => ({
          ...filterPurchase,
          modelFrom: ""
        }));
      }
      setFilteredModelFrom([]);
      setHighlightedIndexModelFrom(-1);
    }
  };

  // Dentro del componente
  const debouncedHandleSearchModelTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredModelTo([]);
      setHighlightedIndexModelTo(-1);
      return;
    }
    const filtered = modelToSelect
      .filter(vehicletype=>(vehicletype.model>=filterPurchase.modeloFrom))
      .filter(vehicletype => vehicletype && vehicletype.model)
      .filter(vehicletype => {
        const model = vehicletype.model.toUpperCase();
        return model.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredModelTo(filtered);
    setHighlightedIndexModelTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectModelTo = (vehicletype) => {
    if (!vehicletype) return; // Validación adicional para evitar errores
    setFilterPurchase(prev => ({
    ...prev,
    modeloTo:  vehicletype.model || ""
  }));
  setFilteredModelTo([]);
  setHighlightedIndexModelTo(-1);
  }; 
  const handleKeyDownModelTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredModelTo.length === 0 && filterPurchase.modeloTo.trim() === "") {
        const filtered = modelToSelect.filter(item=>(item.model>=filterPurchase.modeloFrom));
        setFilteredModelTo(filtered);
        setHighlightedIndexModelTo(0);
      } else {
        setHighlightedIndexModelTo((prevIndex) => {
          const nextIndex = prevIndex < filteredModelTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex,ddRefModelTo);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexModelTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid,ddRefModelTo);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexModelTo >= 0) {
      if (highlightedIndexModelTo >= 0 && highlightedIndexModelTo < filteredModelTo.length) {
        handleSelectModelTo(filteredModelTo[highlightedIndexModelTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = modelToSelect
      .filter(item=>(item.model>=filterPurchase.modeloFrom))
      .some((vehicletype) => {
      if (!vehicletype || !vehicletype.model) return false; 
        const normalizedModel = vehicletype.tradename.toUpperCase();
        const normalizedInputModel = filterPurchase.modeloTo.toUpperCase();
        return normalizedModel === normalizedInputModel;
    }); 
    if (!isValid) {
      setFilterPurchase(filterPurchase => ({
        ...filterPurchase,
        modeloTo:  ""
      }));
    }
    setFilteredModelTo([]);
    setHighlightedIndexMarcaTo(-1);
    }
  }; 

  // Función para desplazar el contenedor
  const scrollToElement = (index, ref) => {
    const dropdown = ref?.current;
    const item = dropdown?.children?.[index];
    if (item) item.scrollIntoView({ behavior: "smooth", block: "nearest" });
  };

  const handleBlur = useCallback((event) => {
    if (!event || !event.currentTarget) return;
    if (!event.currentTarget.contains(event.relatedTarget)) { 
      setFilteredStoreFrom([]);
      setHighlightedIndexStoreFrom(-1); 
      setFilteredStoreTo([]);
      setHighlightedIndexStoreTo(-1); 
      setHighlightedIndexMarcaFrom(-1); 
      setFilteredMarcaFrom([]);
      setHighlightedIndexMarcaTo(-1); 
      setFilteredMarcaTo([]); 
      setHighlightedIndexModelFrom(-1); 
      setFilteredModelFrom([]);
      setHighlightedIndexModelTo(-1); 
      setFilteredModelTo([]); 

    }
  }, []); 
  
  const openCreateOrEditDataPurchaseDelivery = () => {
    setInputTextPurchaseDelivery(""); 
    setOpenEditFilterPurchaseDelivery(!openEditFilterPurchaseDelivery); 
    navigate(typeOfList==="1"?"/purchasedeliverydetailin/0":`/purchasedeliverydetailout/0`);
  };
 
  const openEditFiltersPurchaseDelivery = () => {
      setOpenEditFilterPurchaseDelivery(!openEditFilterPurchaseDelivery);
  };

  const handleSubmitFilterEditPurchaseDelivery = () => {
    setErrorsFiltersPurchaseDelivery(validateFormFilterPurchaseDelivery());
    if (Object.keys(errorsFiltersPurchaseDelivery).length === 0) { 
      setErrorsFiltersPurchaseDelivery({}); 
      dispatch(resetPagination());
      dispatch(setFilters(filterPurchase)); 
      setOpenEditFilterPurchaseDelivery(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }

  const handleDeleteFiltersPurchaseDelivery = () => {
    setErrorsFiltersPurchaseDelivery({});
    dispatch(resetPagination());
    dispatch(resetFilters()); 
    setFilterPurchase(initialState);
    setOpenEditFilterPurchaseDelivery(!openEditFilterPurchaseDelivery);
  };

  const handleCancelFiltersPurchaseDelivery = () => {
    setErrorsFiltersPurchaseDelivery({});
    setOpenEditFilterPurchaseDelivery(!openEditFilterPurchaseDelivery);
  };
 
  const handleChangeSelectDatePurchaseDelivery = (event) => {
    const newDate = event ? new Date(event) : null;
    if (newDate && isNaN(newDate.getTime())) { 
      return; // Salir si la fecha es inválida
    }
    setFilterPurchase(filterPurchase => ({
      ...filterPurchase,
      datepurchaseFrom: newDate
    }));
  };

  const handleBlurSelectDatePurchaseDeliveryFrom = (e) => {
    handleChangeSelectDatePurchaseDelivery(e);
    setErrorsFiltersPurchaseDelivery(validateFormFilterPurchaseDelivery());
  };

  const handleBlurAmountFrom = (value) => {
    handleChangeAmountFrom(value);
    setErrorsFiltersPurchaseDelivery(validateFormFilterPurchaseDelivery());
  };

  const handleChangeAmountFrom = (value) => {
    let newValue=value!==null?Number((value.toLocaleString()).replaceAll(",","").replaceAll(" Tn","").replaceAll("kg","").replaceAll("€","").replaceAll("%","")):0;
    setFilterPurchase(filterPurchase => ({
      ...filterPurchase,
      amountFROM: newValue,
      amountTO: newValue
    }));
  };

  const handleBlurAmountTo = (value) => {
    handleChangeAmountTo(value);
    setErrorsFiltersPurchaseDelivery(validateFormFilterPurchaseDelivery());
  };

  const handleChangeAmountTo = (value) => {
    let newValue=value!==null?Number((value.toLocaleString()).replaceAll(",","").replaceAll(" Tn","").replaceAll("kg","").replaceAll("€","").replaceAll("%","")):0;
    setFilterPurchase(filterPurchase => ({
      ...filterPurchase,
      amountTO: newValue
    }));
  };

  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= 100000000) return true;
    return false;
  };

  const handleChangeSelectDatePurchaseDeliveryTo = (event) => {
    const newDate = event ? new Date(event) : null;
    if (newDate && isNaN(newDate.getTime())) { 
      return; // Salir si la fecha es inválida
    }
    setFilterPurchase(filterPurchase => ({
      ...filterPurchase,
      datepurchaseTo: newDate
    }));
  };

  const handleBlurSelectDatePurchaseDeliveryTo = (e) => {
    handleChangeSelectDatePurchaseDeliveryTo(e);
    setErrorsFiltersPurchaseDelivery(validateFormFilterPurchaseDelivery());
  };

  const handleChangeFilterEditPurchaseDelivery = (e) => {
    const { name, value } = e.target;
    setFilterPurchase(filterPurchase => ({
      ...filterPurchase,
      [name]: value
    })); 
  }; 

  const handleBlurFilterEditPurchaseDelivery = (e) => {
    setErrorsFiltersPurchaseDelivery(validateFormFilterPurchaseDelivery());
    handleChangeFilterEditPurchaseDelivery(e);
  };

  const toggleDrawerFilterEditPurchaseDelivery = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditPurchaseDelivery();
    }
  };

  const handleExport = () => { 
    const fetchDataRegisterBook = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().post6(ENDPOINT,`purchasedelivery/getdatatoexcel`,token,currencyOffsetPurchaseDelivery,LIMIT_PAGE,"-1","-1",(typeOfList==="1" )?"1":"2",filtersPurchaseDelivery);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (getData && getData.length>0) {
          exportToExcel(getData, "RegistrosAlbraranes"); 
        }
        dispatch(setLoading(false)); 
      } catch (error) {
        dispatch(setLoading(false)); 
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    if (dataPurchaseDelivery && dataPurchaseDelivery.length>0){ 
      fetchDataRegisterBook();
    } 
  };

  const handleExportPDF = () => {
    const fetchDataRegisterBook = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().post6(ENDPOINT,`purchasedelivery/getdatatoexcel`,token,currencyOffsetPurchaseDelivery,LIMIT_PAGE,"-1","-1",(typeOfList==="1" )?"1":"2",filtersPurchaseDelivery);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (getData && getData.length>0) {
          exportToPDF(getData, "RegistroAlbraranes", true); 
        }
        dispatch(setLoading(false)); 
      } catch (error) {
        dispatch(setLoading(false)); 
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (dataPurchaseDelivery && dataPurchaseDelivery.length>0){ 
      fetchDataRegisterBook();
    } 
  };
 
  const validateFormFilterPurchaseDelivery = () => {

    let errorsFiltersPurchaseDelivery = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (filterPurchase.idFrom!=="" & !regexNumber.test(filterPurchase.idFrom)) {
      errorsFiltersPurchaseDelivery.idFrom = 'Text_TextNoNumber';
    }
    if (filterPurchase.idTo!=="" & !regexNumber.test(filterPurchase.idTo)) {
      errorsFiltersPurchaseDelivery.idTo = 'Text_TextNoNumber';
    }
    if (filterPurchase.idFrom!=="" & !errorsFiltersPurchaseDelivery.idFrom!==undefined){
      if (filterPurchase.idTo!=="" & !errorsFiltersPurchaseDelivery.idTo!==undefined){
        if (parseInt(filterPurchase.idTo)<parseInt(filterPurchase.idFrom)){
          errorsFiltersPurchaseDelivery.idTo = 'Text_TextGreater_Id';
        }
      }
    }
 
    if (filterPurchase.amountTO!==undefined && filterPurchase.amountTO!=="" && filterPurchase.amountTO>0){
      if (parseFloat(filterPurchase.amountTO)<parseFloat(filterPurchase.amountFROM)){
        errorsFiltersPurchaseDelivery.amountTO = 'Text_TextGreater_AMOUNT';
      } 
    } 
    
    if (regexInvalidCharacters.test(filterPurchase.datepurchaseFrom)) {
      errorsFiltersPurchaseDelivery.datepurchaseFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filterPurchase.datepurchaseTo)) {
      errorsFiltersPurchaseDelivery.datepurchaseTo = 'Text_TextNoValid';
    }

     if (regexInvalidCharacters.test(filterPurchase.purchasenoteFrom)) {
      errorsFiltersPurchaseDelivery.purchasenoteFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filterPurchase.purchasenoteTo)) {
      errorsFiltersPurchaseDelivery.purchasenoteTo = 'Text_TextNoValid';
    }
   
    return errorsFiltersPurchaseDelivery;
  }   
  
  const filteredDataPurchaseDelivery = dataPurchaseDelivery.filter((el) => {
    if (inputTextPurchaseDelivery === '') { 
      return el;
    }
    else {
      let dataTranslate = 
        String(el.purchasenote || '') +
        String(el.opt_tras_tradename || '') +
        String(el.rel_trans_tradename || '') +
        String(el.opt_tras_licenseplate || '') +
        String(el.vehiclestore_frame || '') +
        String(el.vehicle_marca || '') +
        String(el.vehicle_model || '') +
        String(el.totalpurchase ? parseFloat(el.totalpurchase).toFixed(2) : '');
      let result = dataTranslate.toLowerCase().includes(inputTextPurchaseDelivery.toLowerCase());
      return result;
    } 
  }) 
    
  let inputHandlerPurchaseDelivery  = (e) => {
      var lowerCase = e.target.value.toLowerCase();
      setInputTextPurchaseDelivery(lowerCase);
  };

  const handleChangeDeleteRowPurchaseDelivery = (e) => {
    const value  = e.target.value;
    setIdCodeDelete(value);
  };

  const handleCancelDeleteRowPurchaseDelivery = () => {
    setRowEditPurchaseDelivery(initialStatePurchseDelivery[0]);
    setIsLoadingErrorPurchaseDelivery(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowPurchaseDelivery(false);
  };
  
  const handleCloseDeleteRowPurchaseDelivery = (e) => {
    if (idCodeDelete !== DELETE_CODE_FORMDI) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }
    let isMounted = true;
    if (e.key !== 'Escape') {
      if (rowEditPurchaseDelivery.id!=='') {      
        const fetchData = async () => {
          dispatch(setLoading(true));
          try {
            const getData = await helpHttp().del3(ENDPOINT,`purchasedelivery/deletepurchasedelivery`,token,typeOfList==="1"?"1":"2",rowEditPurchaseDelivery);
            if (getData.status === "OK") {
              if (isMounted) {
                dispatch(successErrorAction(t('Text_ValidCode')));
                dispatch(successErrorAction(t('Text_DeleteField')));
                setRefeshData(true);
                dispatch(setLoading(false));
                handleCloseDataEditPurchaseDelivery();
              }
            } else {
              if (isMounted) {
                dispatch(setLoading(false));
                dispatch(warningErrorAction(t(getData.cause)));
              }
            }
          } catch (error) {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }   
        };
        fetchData(); 
      } else {
        dispatch(warningErrorAction(t('Text_InvalidId')));
      }
    }
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowPurchaseDelivery(false);
    setIsLoadingErrorPurchaseDelivery(false);
    handleCloseDataEditPurchaseDelivery(); 
  };
 
  const handleCloseDataEditPurchaseDelivery = () => { 
    setOpenEditRowPurchaseDelivery(false);
    setRowEditPurchaseDelivery(openEditRowPurchaseDelivery?rowEditPurchaseDelivery:initialStatePurchseDelivery[0]);
    dispatch(setLoading(false));
    setIsLoadingErrorPurchaseDelivery(false);
    toggleDrawerFilterEditPurchaseDelivery(false);  
	}; 
  
  useEffect(() => {
    if (numTotRegFilter > Number(LIMIT_PAGE)) {
      setActiveOffsetPurchaseDelivery(true);
      const newRangeOffset = [
        {
          value: 0,
          label: " 1 - " + Number(LIMIT_PAGE).toLocaleString('de-DE'),
        }
      ];
      for (let i = Number(LIMIT_PAGE); i < numTotRegFilter; i += Number(LIMIT_PAGE)) {
        newRangeOffset.push({
          value: i,
          label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMIT_PAGE)).toLocaleString('de-DE'),
        });
      }
      setRangeOffsetPurchaseDelivery(newRangeOffset);
    } else {
      setCurrencyOffsetPurchaseDelivery(0);
      setActiveOffsetPurchaseDelivery(false);
      setRangeOffsetPurchaseDelivery([{}]);
    }
  }, [numTotRegFilter]);

  useEffect(() => {
    if (showModalPurchasesDeliverySettings){
      setFormPurchaseDelivery(formPurchaseDelivery => ({
        ...formPurchaseDelivery,
        id : rowEditPurchaseDelivery.id!==null?rowEditPurchaseDelivery.id:"",
        defaultStore_id : rowEditPurchaseDelivery.defaultStore_id!==null?rowEditPurchaseDelivery.defaultStore_id:0,
        useraccount_id :rowEditPurchaseDelivery.useraccount_id!==null?rowEditPurchaseDelivery.useraccount_id:0,
        substore_id :rowEditPurchaseDelivery.substore_id!==null?rowEditPurchaseDelivery.substore_id:0,
        purchasenote :rowEditPurchaseDelivery.purchasenote!==null?rowEditPurchaseDelivery.purchasenote:"",
        ownnumberpurchase :rowEditPurchaseDelivery.ownnumberpurchase!==null?rowEditPurchaseDelivery.ownnumberpurchase:"",
        opt_tras_tradename :rowEditPurchaseDelivery.opt_tras_tradename!==null?rowEditPurchaseDelivery.opt_tras_tradename:"",
        opt_tras_licenseplate :rowEditPurchaseDelivery.opt_tras_licenseplate!==null?rowEditPurchaseDelivery.opt_tras_licenseplate:"",
        vehiclestore_frame :rowEditPurchaseDelivery.vehiclestore_frame!==null?rowEditPurchaseDelivery.vehiclestore_frame:"",
        vehicle_marca :rowEditPurchaseDelivery.vehicle_marca!==null?rowEditPurchaseDelivery.vehicle_marca:"",
        vehicle_model :rowEditPurchaseDelivery.vehicle_model!==null?rowEditPurchaseDelivery.vehicle_model:"",
        totalpurchase :rowEditPurchaseDelivery.totalpurchase!==null?rowEditPurchaseDelivery.totalpurchase:0,
        payment_id:rowEditPurchaseDelivery.payment_id!==null?rowEditPurchaseDelivery.payment_id:0,
        payment_code:rowEditPurchaseDelivery.payment_code!==null?rowEditPurchaseDelivery.payment_code:"",
        payment_namees:rowEditPurchaseDelivery.payment_namees!==null?rowEditPurchaseDelivery.payment_namees:"",
        payment_nameen:rowEditPurchaseDelivery.payment_nameen!==null?rowEditPurchaseDelivery.payment_nameen:"",
      }));
    }else{
      setFormPurchaseDelivery(initialStatePurchseDelivery[0]);
    }
  },[rowEditPurchaseDelivery,showModalPurchasesDeliverySettings]);
 
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    let isMounted = true; 
    const fetchDataVehiclesMarca = async () => {
      try {
        const getData = await helpHttp().get7(ENDPOINT,`purchasedelivery/getlistvehicletypesmarca`,token,
          filterPurchase.marcaFrom!==undefined && filterPurchase.marcaFrom!==null && filterPurchase.marcaFrom.replace(/[.\-/\\|]/g, "").trim()!==""?filterPurchase.marcaFrom.replace(/[.\-/\\|]/g, ""):"-1",
          filterPurchase.marcaTo!==undefined && filterPurchase.marcaTo!==null && filterPurchase.marcaTo.replace(/[.\-/\\|]/g, "").trim()!==""?filterPurchase.marcaTo.replace(/[.\-/\\|]/g, ""):"-1",
          typeOfList==="1"?"1":"2"); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setMarcaToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };   
    if (showModalPurchasesDeliverySettings ) { 
      fetchDataVehiclesMarca();
    }
    return () => { isMounted = false };

  }, [t,token,dispatch,i18n,roles,filterPurchase,openEditFilterPurchaseDelivery,showModalPurchasesDeliverySettings,typeOfList]);
     
  useEffect(() => {
    let isMounted = true; 
    const fetchDataVehiclesMarca = async () => {
      try {
        const getData = await helpHttp().get7(ENDPOINT,`purchasedelivery/getlistvehicletypesmodel`,token,
          filterPurchase.modeloFrom!==undefined && filterPurchase.modeloFrom!==null && filterPurchase.modeloFrom.replace(/[.\-/\\|]/g, "").trim()!==""?filterPurchase.modeloFrom.replace(/[.\-/\\|]/g, ""):"-1",
          filterPurchase.modeloTo!==undefined && filterPurchase.modeloTo!==null && filterPurchase.modeloTo.replace(/[.\-/\\|]/g, "").trim()!==""?filterPurchase.modeloTo.replace(/[.\-/\\|]/g, ""):"-1",
          typeOfList==="1"?"1":"2"); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setModelToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };   
    if (showModalPurchasesDeliverySettings) { 
      fetchDataVehiclesMarca();
    }
    return () => { isMounted = false };

  }, [t,token,dispatch,i18n,roles,filterPurchase,openEditFilterPurchaseDelivery,showModalPurchasesDeliverySettings,typeOfList]);
    
  useEffect(() => {
    let isMounted = true; 
    const fetchDataPayment = async () => {
      try {
        const getData = i18n.language === "es"
        ? await helpHttp().get(ENDPOINT, `paymenttype/paymenttypesorderbynamees`, token)
        : await helpHttp().get(ENDPOINT, `paymenttype/paymenttypesorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) { 
          setPaymenetTypeSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    const fetchDataTradename = async () => {
      try {
        const getData = await helpHttp().get7(ENDPOINT,`purchasedelivery/getlisttradenamepurchasedelivery`,token,"-1","-1", typeOfList==="1"?"1":"2");
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) { 
          setTradenameToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };   
    if (showModalPurchasesDeliverySettings ) { 
      fetchDataPayment(); 
      fetchDataTradename();
    }
    return () => { isMounted = false };

  }, [t,token,dispatch,i18n,roles,filtersPurchaseDelivery,openEditFilterPurchaseDelivery,showModalPurchasesDeliverySettings,defaultStore.id,useraccount_id,typeOfList]);
 
  useEffect(() => {
    let isMounted = true;
    const fetchnumTotRegPurchaseDelivery = async () => { 
      try {
        const getData  = await helpHttp().get2(ENDPOINT,`purchasedelivery/getinformationpurchasedelivery/`,token,(typeOfList==="1" )?"1":"2");
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            if (getData.message==="Load failed"){
              dispatch(warningErrorAction(t('Text_ConnectionFailied')));
            }else {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            }   
          }
        } else if (isMounted) {
          setNumTotRegPurchaseDelivery(getData); 
        } 
      } catch (error) { 
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = await helpHttp().post4(ENDPOINT,`purchasedelivery/getcountfilterpurchasedelivery`,token,"-1","-1",(typeOfList==="1")?"1":"2",filtersPurchaseDelivery);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            if (getData.message==="Load failed"){
              dispatch(warningErrorAction(t('Text_ConnectionFailied')));
            }else {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            }  
          }
        } else if (isMounted) {
          setNumTotRegFilter(getData);  
          fetchDataPurchaseDelivery(); 
        } 
      } catch (error) {
        dispatch(setLoading(false)); 
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      } 
    }; 
    
    const fetchDataPurchaseDelivery = async () => {
      try {
        dispatch(setLoading(false));
        const getData = await helpHttp().post6(ENDPOINT,`purchasedelivery/getpurchasedelivery`,token,currencyOffsetPurchaseDelivery,numTotRegFilter<=LIMIT_PAGE_SIZE_SLIDE?numTotRegFilter:LIMIT_PAGE_SIZE_SLIDE,"-1","-1",(typeOfList==="1" )?"1":"2",filtersPurchaseDelivery);
        if (getData.err) {
          dispatch(setLoading(false));
          setDataPurchaseDelivery(initialStatePurchseDelivery);
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else {
          setDataPurchaseDelivery(getData); 
          dispatch(setLoading(false));
          if (numTotRegFilter>LIMIT_PAGE_SIZE_SLIDE){
            fetchDataSecondPurchaseDelivery();
          } 
        } 
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    };

    const fetchDataSecondPurchaseDelivery = async () => {
      try {
        const getData = await helpHttp().post6(ENDPOINT,`purchasedelivery/getpurchasedelivery`,token,currencyOffsetPurchaseDelivery,LIMIT_PAGE,"-1","-1",(typeOfList==="1" )?"1":"2",filtersPurchaseDelivery);
        if (getData.err) { 
          setDataPurchaseDelivery(initialStatePurchseDelivery);
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataPurchaseDelivery(getData);  
        } 
      } catch (error) { 
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    };
  
    if (showModalPurchasesDeliverySettings || refeshData){ 
      fetchnumTotRegPurchaseDelivery();
      fetchnumTotRegFilter();   
      setRefeshData(false); 
    }    
    return () => { isMounted = false; };
  }, [t,roles,token,dispatch,i18n.language,numTotRegFilter,filtersPurchaseDelivery,showModalPurchasesDeliverySettings,currencyOffsetPurchaseDelivery,defaultStore.id,useraccount_id ,openDeleteRowPurchaseDelivery,setOpenDeleteRowPurchaseDelivery,setOpenEditRowPurchaseDelivery,openEditRowPurchaseDelivery,rowEditPurchaseDelivery,setRowEditPurchaseDelivery,defaultStore,typeOfList,refeshData ]);
 
  return (
    <>
      {showModalPurchasesDeliverySettings ? ( 
        <div className="container-fluid formdi-pending-page">
          {/* Search input */}
          <div id="myDIV" className="formdi-pending-header">
            <h1 className="formdi-pending-title">{isLoadingErrorPurchaseDelivery ?(<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>) : isLoadingData ? ( <CircularProgress color={openDeleteRowPurchaseDelivery ? "warning" : "primary"} />) : (<i className="fas fa-regular fa-highlighter text-warning"></i>)}{" "} {typeOfList === "1" ? t("Text_PurchaseDeliveryEnded_Table") : t("Text_PurchaseDelivery_Table")}</h1>
              {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Purchases_Create')) ? (
              <div>
                <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={openCreateOrEditDataPurchaseDelivery} >
                  {t('Button_Create')}
                </button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalPurchaseDelivery} >
                  {t("Button_Back")}
                </button>
              </div>
            ) : (
              <div>
                <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary" onClick={closeModalPurchaseDelivery} >
                  {t("Button_Back")}
                </button>
              </div>
            )} 
          </div>   
          {/* Buscador */}
          <div className="formdi-pending-search">
            <TextField
              id="outlined-basic"
              variant="outlined"
              value={inputTextPurchaseDelivery}
              inputProps={{ style: {fontSize: '18px'} }}
              InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
              placeholder={t('Text_PurchaseDelivery_Search')} 
              onChange={inputHandlerPurchaseDelivery }
              fullWidth
              label={t('Text_PurchaseDelivery_Search')}>
            </TextField>
          </div>
          <br/>
          <div id="myNewDIV" className="formdi-pending-filters">
            <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
            <div className="formdi-pending-filters-row">
              <button type="button" className={`formdi-pending-chip ${filtersPurchaseDelivery.idFrom!=="" || filtersPurchaseDelivery.idTo!==""? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersPurchaseDelivery} >
                <span className={`formdi-pending-dot ${ filtersPurchaseDelivery.idFrom!=="" || filtersPurchaseDelivery.idTo!==""? "formdi-pending-dot--on": ""}`}/>
                  {t('Text_PURCHASEDELIVERY_NUMPURCHASE').toUpperCase()}
              </button>
              <button type="button" className={`formdi-pending-chip ${(filtersPurchaseDelivery.datepurchaseFrom!==null|| filtersPurchaseDelivery.datepurchaseTo!==null)? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersPurchaseDelivery} >
                <span className={`formdi-pending-dot ${(filtersPurchaseDelivery.datepurchaseFrom!==null|| filtersPurchaseDelivery.datepurchaseTo!==null)? "formdi-pending-dot--on": ""}`}/>
                  {t('Text_Dates').toUpperCase()}
              </button>
              <button type="button" className={`formdi-pending-chip ${(filtersPurchaseDelivery.opt_tras_store_idFrom!=="" || filtersPurchaseDelivery.opt_tras_store_idTo!=="" )? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersPurchaseDelivery} >
                <span className={`formdi-pending-dot ${(filtersPurchaseDelivery.opt_tras_store_idFrom!=="" || filtersPurchaseDelivery.opt_tras_store_idTo!=="" )? "formdi-pending-dot--on": ""}`}/>
                  {t('Text_PURCHASE_PROVIDER_TRADENAME').toUpperCase()}
              </button>
              <button type="button" className={`formdi-pending-chip ${(filtersPurchaseDelivery.marcaFrom!=="" || filtersPurchaseDelivery.marcaTo!=="" )? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersPurchaseDelivery} >
                <span className={`formdi-pending-dot ${(filtersPurchaseDelivery.marcaFrom!=="" || filtersPurchaseDelivery.marcaTo!=="" )? "formdi-pending-dot--on": ""}`}/>
                  {t('Text_PURCHASE_VEHICLE_MARCA').toUpperCase()}
              </button>
              <button type="button" className={`formdi-pending-chip ${(filtersPurchaseDelivery.modeloFrom!=="" || filtersPurchaseDelivery.modeloTo!=="" )? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersPurchaseDelivery} >
                <span className={`formdi-pending-dot ${(filtersPurchaseDelivery.modeloFrom!=="" || filtersPurchaseDelivery.modeloTo!=="" )? "formdi-pending-dot--on": ""}`}/>
                  {t('Text_PURCHASE_VEHICLE_MODEL').toUpperCase()}
              </button>
              <button type="button" className={`formdi-pending-chip ${(filtersPurchaseDelivery.amountFROM!==0 || filtersPurchaseDelivery.amountTO!==0)? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersPurchaseDelivery} >
                <span className={`formdi-pending-dot ${(filtersPurchaseDelivery.amountFROM!==0 || filtersPurchaseDelivery.amountTO!==0)? "formdi-pending-dot--on": ""}`}/>
                  {t('Text_PurchaseDeliver_TOTAL').toUpperCase()}
              </button>
               <button type="button" className={`formdi-pending-chip ${(filtersPurchaseDelivery.paymentFromES!=="" || filtersPurchaseDelivery.paymentToES!=="" || filtersPurchaseDelivery.paymentFromEN!=="" || filtersPurchaseDelivery.paymentToEN!=="")? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersPurchaseDelivery} >
                <span className={`formdi-pending-dot ${(filtersPurchaseDelivery.paymentFromES!=="" || filtersPurchaseDelivery.paymentToES!=="" || filtersPurchaseDelivery.paymentFromEN!=="" || filtersPurchaseDelivery.paymentToEN!=="")? "formdi-pending-dot--on": ""}`}/>
                  {t('Text_PurchaseDeliver_Payment').toUpperCase()}
              </button>
              <button type="button" className="formdi-pdf-chip" onClick={handleExportPDF}>
                {t('Button_PDF')}
              </button>
              {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Purchases_Handle_Excel")) && (
                <button type="button" className="formdi-excel-chip" onClick={handleExport}>
                  {t('Button_Excel')}
                </button>
              )}   
               
            </div>
          </div>
          <br/>  
          {!isLoadingData ?
            <>
              <div className="card shadow mb-4">    
                <div className="card-body">
                  <TableSortingPurchaseDelivery
                    dataPurchaseDelivery={filteredDataPurchaseDelivery}
                    numTotRegFilter={ numTotRegFilter}
                    titleTable={(typeOfList==="1" )?t('Text_PurchaseDeliveryEnded_Table'):t('Text_PurchaseDelivery_Table')}
                    setOpenDeleteRowPurchaseDelivery={setOpenDeleteRowPurchaseDelivery} 
                    setRowEditPurchaseDelivery={setRowEditPurchaseDelivery}
                    showEditButtonPurchaseDelivery={roles[0].listmenus.find((key)=>(key.name==='SubMenu_Purchases_Edit'))?true:false}
                    showDeleteButtonPurchaseDelivery={roles[0].listmenus.find((key)=>(key.name==='SubMenu_Purchases_Delete'))?true:false}
                    numTotRegPurchaseDelivery={numTotRegPurchaseDelivery}
                    activeOffsetPurchaseDelivery={activeOffsetPurchaseDelivery}
                    rangeOffsetPurchaseDelivery={rangeOffsetPurchaseDelivery}
                    currencyOffsetPurchaseDelivery={currencyOffsetPurchaseDelivery}
                    setCurrencyOffsetPurchaseDelivery={setCurrencyOffsetPurchaseDelivery}
                    showPrintButtonPurchaseDelivery={roles[0].listmenus.find((key)=>(key.name==='SubMenu_Purchases_Print'))?true:false}
                    showEmailButtonPurchaseDelivery={roles[0].listmenus.find((key)=>(key.name==='SubMenu_Purchases_Handle_EMAILs'))?true:false} 
                    setViewPDF={setViewPDF} 
                    typeOfList={typeOfList}
                    formPurchaseDelivery={formPurchaseDelivery}
                  >
                  </TableSortingPurchaseDelivery>
                </div>             
              </div>
              
              {openEditFilterPurchaseDelivery &&
               <div>
               <SwipeableDrawer
                 anchor='right'
                 open={true}
                 onClose={toggleDrawerFilterEditPurchaseDelivery(false)}
                 onOpen={toggleDrawerFilterEditPurchaseDelivery(true)}>
                 <Container >
                   <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850' }}>
                     <br/>
                       <div id="myDIV">
                         <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                       </div>
                       <hr className="sidebar-divider d-none d-md-block"/>
                       <form className="createfilterpurchasedelivery" onSubmit={handleCancelFiltersPurchaseDelivery}>  
                         <div className="form-floating mb-3 px-4 primary">
                           <div className="form-group">
                              <NumericFormat 
                                thousandSeparator={''} 
                                decimalSeparator={'.'} 
                                decimalScale= {0}
                                fixedDecimalScale= {true}
                                allowNegative= {false}
                                isAllowed={withValueCap}
                                id="idFrom" 
                                name="idFrom" 
                                value={filterPurchase.idFrom}
                                label={errorsFiltersPurchaseDelivery.idFrom!=null?t(errorsFiltersPurchaseDelivery.idFrom):t('Text_Filter_Code_From')}
                                placeholder={t('PlaceHolder_Filter_Code_From')}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 20 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                customInput={TextField}
                                onBlur={handleBlurFilterEditPurchaseDelivery}
                                onChange={handleChangeFilterEditPurchaseDelivery} 
                              /> 
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                             <NumericFormat 
                                thousandSeparator={''} 
                                decimalSeparator={'.'} 
                                decimalScale= {0}
                                fixedDecimalScale= {true}
                                allowNegative= {false}
                                isAllowed={withValueCap}
                                id="idTo" 
                                name="idTo" 
                                value={filterPurchase.idTo}
                                label={errorsFiltersPurchaseDelivery.idTo!=null?t(errorsFiltersPurchaseDelivery.idTo):t('Text_Filter_Code_To')}
                                placeholder={t('PlaceHolder_Filter_Code_to')}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 20 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                customInput={TextField}
                                onBlur={handleBlurFilterEditPurchaseDelivery}
                                onChange={handleChangeFilterEditPurchaseDelivery} 
                              />  
                          </div> 
                          <div className="form-group">
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                <DesktopDatePicker
                                  id="datepurchaseFrom" 
                                  name="datepurchaseFrom"
                                  value={ filterPurchase.datepurchaseFrom!== null ? new Date(filterPurchase.datepurchaseFrom): null}
                                  format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                  label={errorsFiltersPurchaseDelivery.datepurchaseFrom!=null?t(errorsFiltersPurchaseDelivery.datepurchaseFrom):t('Text_Filter_DatePurchase_From')}
                                  onBlur={handleBlurSelectDatePurchaseDeliveryFrom}
                                  onChange={handleChangeSelectDatePurchaseDelivery}
                                  slotProps={{
                                    textField: {
                                      placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                      sx: {
                                        color: '#1565c0',
                                        maxLength: '100',
                                        width: 430,  
                                        fontSize: '18px'
                                      },
                                      InputProps: {
                                        style: {
                                          fontSize: '18px',
                                        }
                                      },
                                      InputLabelProps:{ 
                                        style: {
                                          fontSize: '18px', 
                                          background: '#FFFFFF'
                                        }
                                      },
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                <DesktopDatePicker
                                  id="datepurchaseTo" 
                                  name="datepurchaseTo"
                                  minDate={filterPurchase.datepurchaseFrom!== null ? new Date(filterPurchase.datepurchaseFrom): null}
                                  value={ filterPurchase.datepurchaseTo!== null ? new Date(filterPurchase.datepurchaseTo): null}
                                  format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                  label={errorsFiltersPurchaseDelivery.datepurchaseTo!=null?t(errorsFiltersPurchaseDelivery.datepurchaseTo):t('Text_Filter_DatePurchase_To')}
                                  onBlur={handleBlurSelectDatePurchaseDeliveryTo}
                                  onChange={handleChangeSelectDatePurchaseDeliveryTo}
                                  slotProps={{
                                    textField: {
                                      placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                      sx: {
                                        color: '#1565c0',
                                        maxLength: '100',
                                        width: 430,  
                                        fontSize: '18px'
                                      },
                                      InputProps: {
                                        style: {
                                          fontSize: '18px',
                                        }
                                      },
                                      InputLabelProps:{ 
                                        style: {
                                          fontSize: '18px', 
                                          background: '#FFFFFF'
                                        }
                                      },
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                          </div>     
                          <div className="form-group">
                            {/* Campo de texto para escribir y filtrar */}
                            <span style={{ position: "relative" }}>
                              <TextField
                                id="opt_tras_store_idFrom"
                                name="opt_tras_store_idFrom"
                                value={filterPurchase.opt_tras_store_idFrom}
                                onChange={(e) => {
                                  setFilterPurchase(prev => ({
                                    ...prev,
                                    opt_tras_store_idFrom: e.target.value.toUpperCase(),
                                    opt_tras_store_idTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchStoreFrom(e.target.value);
                                }}
                                onKeyDown={handleKeyDownStoreFrom}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsFiltersPurchaseDelivery.opt_tras_store_idFrom != null
                                  ? t(errorsFiltersPurchaseDelivery.opt_tras_store_idFrom)
                                  : t('Text_Filter_Provider_From')}
                                placeholder={t('PlaceHolder_Filter_Provider_From')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              />
                              {filteredStoreFrom.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredStoreFrom.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectStoreFrom(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexStoreFrom ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexStoreFrom ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )} 
                              </span>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                              <span style={{ position: "relative" }} >
                              <TextField
                                id="opt_tras_store_idTo"
                                name="opt_tras_store_idTo"
                                value={filterPurchase.opt_tras_store_idTo}
                                onChange={(e) => {
                                  setFilterPurchase(prev => ({
                                    ...prev,
                                    opt_tras_store_idTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchStoreTo(e.target.value);
                                }}
                                onKeyDown={handleKeyDownStoreTo}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsFiltersPurchaseDelivery.opt_tras_store_idTo != null
                                  ? t(errorsFiltersPurchaseDelivery.opt_tras_store_idTo)
                                  : t('Text_Filter_Provider_To')}
                                placeholder={t('PlaceHolder_Filter_Provider_To')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              />
                              {filteredStoreTo.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredStoreTo.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectStoreTo(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexStoreTo ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexStoreTo ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                            </span>
                          </div>   
                          <div className="form-group">
                            {/* Campo de texto para escribir y filtrar */}
                            <span style={{ position: "relative" }}>
                              <TextField
                                id="opt_tras_licenseplateFrom"
                                name="opt_tras_licenseplateFrom"
                                value={filterPurchase.opt_tras_licenseplateFrom}
                                onChange={(e) => {
                                  setFilterPurchase(prev => ({
                                    ...prev,
                                    opt_tras_licenseplateFrom: e.target.value.toUpperCase(),
                                    opt_tras_licenseplateTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchVehicleFrom(e.target.value);
                                }}
                                onKeyDown={handleKeyDownVehicleFrom}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsFiltersPurchaseDelivery.opt_tras_licenseplateFrom != null
                                  ? t(errorsFiltersPurchaseDelivery.opt_tras_licenseplateFrom)
                                  : t('Text_Filter_LicensePlate_From')}
                                placeholder={t('PlaceHolder_Filter_LicensePlate_From')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              /> 
                              {/* Desplegable dinámico */}
                              {filteredVehicleFrom.length > 0 && (
                                <div
                                  ref={ddRefVehicleFrom}
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                >
                                  {filteredVehicleFrom.map((vehicle, index) => (
                                    <MenuItem
                                        key={vehicle.id}
                                        onClick={() => handleSelectVehicleFrom(vehicle)}
                                        style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: '18px',
                                            backgroundColor:
                                            index === highlightedIndexVehicleFrom ? "#4e73df" : "transparent",
                                            color: index === highlightedIndexVehicleFrom ? "white" : "black",
                                        }}
                                    >
                                      {vehicle.licenseplate}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                              </span>  
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                              <span style={{ position: "relative" }}>
                                <TextField
                                  id="opt_tras_licenseplateTo"
                                  name="opt_tras_licenseplateTo"
                                  value={filterPurchase.opt_tras_licenseplateTo}
                                  onChange={(e) => {
                                    setFilterPurchase(prev => ({
                                      ...prev,
                                      opt_tras_licenseplateTo: e.target.value.toUpperCase()
                                    }));
                                    debouncedHandleSearchVehicleTo(e.target.value);
                                  }}
                                  onKeyDown={handleKeyDownVehicleTo}
                                  onBlur={(event) => {
                                    if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                      handleBlur();
                                    }
                                  }}
                                  label={errorsFiltersPurchaseDelivery.opt_tras_licenseplateTo != null
                                    ? t(errorsFiltersPurchaseDelivery.opt_tras_licenseplateTo)
                                    : t('Text_Filter_LicensePlate_To')}
                                  placeholder={t('PlaceHolder_Filter_LicensePlate_To')}
                                  inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                  InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                  variant="outlined"
                                />  
                                {/* Desplegable dinámico */}
                                {filteredVehicleTo.length > 0 && (
                                <div
                                  ref={ddRefVehicleTo}
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                >
                                  {filteredVehicleTo.map((vehicle, index) => (
                                    <MenuItem
                                      key={vehicle.id}
                                        onClick={() => handleSelectVehicleTo(vehicle)}
                                        style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: '18px',
                                            backgroundColor:
                                            index === highlightedIndexVehicleTo ? "#4e73df" : "transparent",
                                            color: index === highlightedIndexVehicleTo ? "white" : "black",
                                        }}
                                      >
                                        {vehicle.licenseplate}
                                      </MenuItem>
                                  ))}
                                </div>
                              )}    
                            </span>  
                          </div>   
                          <div className="form-group">
                            <span style={{ position: "relative" }}>
                              <TextField
                                id="marcaFrom"
                                name="marcaFrom"
                                value={filterPurchase.marcaFrom}
                                onChange={(e) => {
                                  setFilterPurchase(prev => ({
                                    ...prev,
                                    marcaFrom: e.target.value.toUpperCase(),
                                    marcaTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchMarcaFrom(e.target.value);
                                }}
                                onKeyDown={handleKeyDownMarcaFrom}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsFiltersPurchaseDelivery.marcaFrom != null
                                  ? t(errorsFiltersPurchaseDelivery.marcaFrom)
                                  : t('Text_Filter_marcaFrom')}
                                placeholder={t('PlaceHolder_Filter_marcaFrom')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              />
                              {filteredMarcaFrom.length > 0 && (
                                <div
                                  ref={ddRefMarcaFrom}
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredMarcaFrom.map((vehicletype, index) => (
                                    <MenuItem
                                      key={vehicletype.id}
                                      onClick={() => handleSelectMarcaFrom(vehicletype)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexMarcaFrom ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexMarcaFrom ? "white" : "black",
                                      }}
                                    >
                                      {vehicletype.marca}
                                    </MenuItem>
                                  ))}
                                </div>
                              )} 
                              </span>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <span style={{ position: "relative" }} >
                                <TextField
                                  id="marcaTo"
                                  name="marcaTo"
                                  value={filterPurchase.marcaTo}
                                  onChange={(e) => {
                                    setFilterPurchase(prev => ({
                                      ...prev,
                                      marcaTo: e.target.value.toUpperCase()
                                    }));
                                    debouncedHandleSearchMarcaTo(e.target.value);
                                  }}
                                  onKeyDown={handleKeyDownMarcaTo}
                                  onBlur={(event) => {
                                    if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                      handleBlur();
                                    }
                                  }}
                                  label={errorsFiltersPurchaseDelivery.marcaTo != null
                                    ? t(errorsFiltersPurchaseDelivery.marcaTo)
                                    : t('Text_Filter_marcaTo')}
                                  placeholder={t('PlaceHolder_Filter_marcaTo')}
                                  inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                  InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                  variant="outlined"
                              />
                              {filteredMarcaTo.length > 0 && (
                                <div
                                  ref={ddRefMarcaTo}
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredMarcaTo.map((vehicletype, index) => (
                                    <MenuItem
                                      key={vehicletype.id}
                                      onClick={() => handleSelectMarcaTo(vehicletype)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexMarcaTo ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexMarcaTo ? "white" : "black",
                                      }}
                                    >
                                      {vehicletype.marca} 
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                            </span>  
                          </div>

                          <div className="form-group">
                            <span style={{ position: "relative" }}>
                              <TextField
                                id="modeloFrom"
                                name="modeloFrom"
                                value={filterPurchase.modeloFrom}
                                onChange={(e) => {
                                  setFilterPurchase(prev => ({
                                    ...prev,
                                    modeloFrom: e.target.value.toUpperCase(),
                                    modeloTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchModelFrom(e.target.value);
                                }}
                                onKeyDown={handleKeyDownModelFrom}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsFiltersPurchaseDelivery.modeloFrom != null
                                  ? t(errorsFiltersPurchaseDelivery.modeloFrom)
                                  : t('Text_Filter_modeloFrom')}
                                placeholder={t('PlaceHolder_Filter_modeloFrom')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              />
                              {filteredModelFrom.length > 0 && (
                                <div
                                  ref={ddRefModelFrom}
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredModelFrom.map((vehicletype, index) => (
                                    <MenuItem
                                      key={vehicletype.id}
                                      onClick={() => handleSelectModelFrom(vehicletype)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexModelFrom ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexModelFrom ? "white" : "black",
                                      }}
                                    >
                                      {vehicletype.model}
                                    </MenuItem>
                                  ))}
                                </div>
                              )} 
                              </span>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <span style={{ position: "relative" }} >
                                <TextField
                                  id="modeloTo"
                                  name="modeloTo"
                                  value={filterPurchase.modeloTo}
                                  onChange={(e) => {
                                    setFilterPurchase(prev => ({ 
                                       ...prev, 
                                       modeloTo: e.target.value.toUpperCase() 
                                    }));
                                    debouncedHandleSearchModelTo(e.target.value);
                                  }}
                                  onKeyDown={handleKeyDownModelTo}
                                  onBlur={(event) => {
                                    if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                      handleBlur();
                                    }
                                  }}
                                  label={errorsFiltersPurchaseDelivery.modeloTo != null
                                    ? t(errorsFiltersPurchaseDelivery.modeloTo)
                                    : t('Text_Filter_mmodeloTo')}
                                  placeholder={t('PlaceHolder_Filter_mmodeloTo')}
                                  inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                  InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                  variant="outlined"
                              />
                              {filteredModelTo.length > 0 && (
                                <div
                                  ref={ddRefModelTo}
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredModelTo.map((vehicletype, index) => (
                                    <MenuItem
                                      key={vehicletype.id}
                                      onClick={() => handleSelectModelTo(vehicletype)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexModelTo ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexModelTo ? "white" : "black",
                                      }}
                                    >
                                      {vehicletype.model} 
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                            </span>  
                          </div>
                          <div className="form-group">
                              <NumericFormat 
                                thousandSeparator={''} 
                                decimalSeparator={'.'} 
                                decimalScale= {2}
                                fixedDecimalScale= {true}
                                allowNegative= {false}
                                isAllowed={withValueCap}
                                id="amountFROM" 
                                name="amountFROM" 
                                value={filterPurchase.amountFROM}
                                label={errorsFiltersPurchaseDelivery.amountFROM!=null?t(errorsFiltersPurchaseDelivery.amountFROM):t('Text_Filter_amount_From')}
                                placeholder={t('PlaceHolderFilter_amount_From')}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 20 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                customInput={TextField}
                                onBlur={(e) => handleBlurAmountFrom(e.target.value)}
                                onChange={(e) => handleChangeAmountFrom(e.target.value)}
                              /> 
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                             <NumericFormat 
                                thousandSeparator={''} 
                                decimalSeparator={'.'} 
                                decimalScale= {2}
                                fixedDecimalScale= {true}
                                allowNegative= {false}
                                isAllowed={withValueCap}
                                id="amountTO" 
                                name="amountTO" 
                                value={filterPurchase.amountTO}
                                label={errorsFiltersPurchaseDelivery.amountTO!=null?t(errorsFiltersPurchaseDelivery.amountTO):t('Text_Filter_amount_To')}
                                placeholder={t('PlaceHolder_Filter_amount_To')}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 20 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                customInput={TextField}
                                onBlur={(e) => handleBlurAmountTo(e.target.value)}
                                onChange={(e) => handleChangeAmountTo(e.target.value)}
                              />  
                          </div> 

                          <div className="form-group">
                            <TextField
                              id={i18n.language==="es"?"paymentFromES":"paymentFromEN"}
                              name={i18n.language==="es"?"paymentFromES":"paymentFromEN"}
                              value={i18n.language==="es"?filterPurchase.paymentFromES:filterPurchase.paymentFromEN}
                              inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={i18n.language==="es"?errorsFiltersPurchaseDelivery.paymentFromES!=null?t(errorsFiltersPurchaseDelivery.paymentFromES):t('Text_Filter_payment_From'):errorsFiltersPurchaseDelivery.paymentFromEN!=null?t(errorsFiltersPurchaseDelivery.paymentFromEN):t('Text_Filter_payment_From')}
                              placeholder={t('PlaceHolder_Filter_payment_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditPurchaseDelivery}
                              onChange={handleChangeFilterEditPurchaseDelivery}
                              select
                              SelectProps={{
                              native: true,
                              }}>
                              <option key={0} value=""/>
                              {paymenetTypeSelect.map((option) => (
                              <option key={option.id} value={i18n.language==="es"?option.namees:option.nameen}>
                                  {i18n.language==="es"?option.namees:option.nameen}
                              </option>
                              ))}
                            </TextField>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                            <TextField
                              id={i18n.language==="es"?"paymentToES":"paymentToEN"}
                              name={i18n.language==="es"?"paymentToES":"paymentToEN"}
                              value={i18n.language==="es"?filterPurchase.paymentToES:filterPurchase.paymentToEN}
                              inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={i18n.language==="es"?errorsFiltersPurchaseDelivery.paymentToES!=null?t(errorsFiltersPurchaseDelivery.paymentToES):t('Text_Filter_payment_To'):errorsFiltersPurchaseDelivery.paymentToEN!=null?t(errorsFiltersPurchaseDelivery.paymentToEN):t('Text_Filter_payment_To')}
                              placeholder={t('PlaceHolder_Filter_payment_To')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditPurchaseDelivery}
                              onChange={handleChangeFilterEditPurchaseDelivery}
                              select
                              SelectProps={{
                              native: true,
                              }}>
                              <option key={0} value=""/>
                              {paymenetTypeSelect.filter(item=>(i18n.language==="es"?item.namees>=filterPurchase.paymentFromES:item.nameen>=filterPurchase.paymentFromEN)).map(option => (
                              <option key={option.id} value={i18n.language==="es"?option.namees:option.nameen}>
                                  {i18n.language==="es"?option.namees:option.nameen}
                              </option>
                              ))}
                              </TextField>
                          </div>  
                        </div>
                        <hr className="sidebar-divider d-none d-md-block" />
                        <div className="formdi-pending-action-group">
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditPurchaseDelivery}>
                            {t('Button_Apply')}
                          </button> 
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersPurchaseDelivery}>
                            {t('Button_Cancel_Filters')}
                          </button>
                        </div>   
                     </form>
                   </Box>
                 </Container>
               </SwipeableDrawer>
              </div>
              }  
              <PurchaseDeliveryPDF 
                key={rowEditPurchaseDelivery.id} 
                rowEditPurchaseDelivery={rowEditPurchaseDelivery} 
                viewPDF={viewPDF} 
                setViewPDF={setViewPDF}
                typeOfList={typeOfList}
              />
              <Dialog open={openDeleteRowPurchaseDelivery} onClose={handleCancelDeleteRowPurchaseDelivery} PaperProps={{ className: "my-dialog-paper-danger" }} >
                <DialogTitle className="my-dialog-title-danger">
                  {t("Text_Delete")} {rowEditPurchaseDelivery.purchasenote} - {rowEditPurchaseDelivery.datepurchase !== null &&  rowEditPurchaseDelivery.datepurchase !== "" ? new Date(rowEditPurchaseDelivery.datepurchase).toLocaleDateString(i18n.language === "es" ? "es-ES" : "en-US") : ""} - {rowEditPurchaseDelivery.opt_tras_tradename}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText className="my-dialog-contentText-danger">
                    {t("Text_Line1")}<br />
                    {t("Text_Line2")}
                  </DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="idCode"
                    label={t("Text_Label")}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="my-dialog-input-danger"
                    defaultValue={idCodeDelete}
                    onChange={handleChangeDeleteRowPurchaseDelivery}
                  />
                </DialogContent>
                <DialogActions className="my-dialog-actions">
                  <Button
                    onClick={handleCancelDeleteRowPurchaseDelivery}
                    className="my-dialog-button-cancel-danger"
                  >
                    {t("Button_Cancel")}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleCloseDeleteRowPurchaseDelivery}
                    className="my-dialog-button-delete"
                  >
                    {t("Button_Delete")}
                  </Button>
                </DialogActions>
              </Dialog> 
          </>:
            <LoadingNews/>
          }
        </div>
        //* End Page Content *//
      ) :  null }
    </>
  )
}

PurchaseDeliveryFilter.propTypes = {
  showModalPurchasesDeliverySettings: PropTypes.bool.isRequired,
  setShowModalPurchasesDeliverySettings: PropTypes.func.isRequired,
  typeOfList: PropTypes.string.isRequired
};

export default PurchaseDeliveryFilter;

